import { render, staticRenderFns } from "./news-classify-form.vue?vue&type=template&id=80a4a636&"
import script from "./news-classify-form.vue?vue&type=script&lang=js&"
export * from "./news-classify-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports